import { LiveViewContainer } from "@/features/deployment-dashboard";

export function LiveViewRoute() {
  return <LiveViewContainer />;
}
